import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { UntilDestroy } from '@ngneat/until-destroy';
import { UserUIModel } from '@y42/user/models';

export enum OrchestrationTriggeredByOrigin {
  User = 'user',
  Orchestrator = 'orchestrator',
}

export interface OrchestrationTriggeredBy {
  origin: OrchestrationTriggeredByOrigin;
  user?: UserUIModel;
}

@UntilDestroy()
@Component({
  selector: 'y42-orchestration-triggered-by',
  templateUrl: './orchestration-triggered-by.component.html',
  styleUrls: ['./orchestration-triggered-by.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class OrchestrationTriggeredByComponent {
  @Input() triggeredBy?: OrchestrationTriggeredBy;
}
